import { render, staticRenderFns } from "./LastQuarterRevenueAverage.vue?vue&type=template&id=567adb48&scoped=true"
import script from "./LastQuarterRevenueAverage.vue?vue&type=script&lang=js"
export * from "./LastQuarterRevenueAverage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567adb48",
  null
  
)

export default component.exports